// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const inn: CountryValidator<"RU"> = createValidator(
  "ru.inn",
  153,
);

export default inn;
export const compact = inn.compact;
export const format = inn.format;
export const validate = inn.validate;
export const generate = (): string =>
  inn.generate?.() ??
  (() => {
    throw new Error(
      "Validator ru.inn cannot generate values",
    );
  })();
